module.exports = __webpack_public_path__ + "static/media/Faith.03fee597.JPG";